<div class="entity-config-page container-fluid">
  <blocking-loader-overlay
    :show="loading_entries"
    :message="page_loading_message"
    :detail="page_loading_detail"
  />
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm mb-1">
      <div class="entity-config-top-hero px-2 px-md-2 pt-2 pb-1">
        <div class="row g-2 align-items-start">
          <div class="col">
            <div class="text-uppercase text-xxs text-white opacity-75 d-flex align-items-center gap-2 mb-2">
              <span>Handler</span>
              <span>/</span>
              <span>Time entry</span>
            </div>
            <h1 class="entity-page-title text-white lh-sm mb-2">Weekly timesheet</h1>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-0">
        <section class="row entity-config-top-metrics g-2">
          <div v-for="metric in metrics" :key="metric.label" class="col-12 col-sm-6 col-xl-3 mb-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                <span class="entity-metric-label secondary-color text-uppercase d-block mb-2">
                  {{ metric.label }}
                </span>
                <div class="entity-metric-value secondary-color lh-1 mb-0 mt-1">{{ metric.value }}</div>
                <div class="text-x mb-0 mt-2 secondary-color">{{ metric.change }}</div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="row g-0 mt-2">
      <div class="col-12 p-0 m-0 px-2">
        <div class="entity-detail-panel rounded-4 border-0 h-100 mt-0">
          <div class="d-flex align-items-center gap-2 flex-wrap mb-3">
            <button
              type="button"
              class="btn btn-sm rounded-pill px-3"
              :class="active_tab === 'entry' ? 'btn-primary-dark' : 'btn-light border secondary-color'"
              @click="active_tab = 'entry'"
            >
              Weekly timesheet
            </button>
            <button
              type="button"
              class="btn btn-sm rounded-pill px-3"
              :class="active_tab === 'submitted' ? 'btn-primary-dark' : 'btn-light border secondary-color'"
              @click="active_tab = 'submitted'"
            >
              Submitted timesheets
            </button>
          </div>

          <div v-if="active_tab === 'entry'">
            <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3 mb-3">
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <div class="case-owner-timesheet-range bg-white d-inline-flex align-items-center rounded-4 border overflow-hidden">
                  <button type="button" class="btn border-0 rounded-0 px-3 small secondary-color" @click="previous_week">&larr;</button>
                  <div class="px-4 py-2 small fw-semibold secondary-color text-center case-owner-timesheet-range-label">{{ range_label }}</div>
                  <button type="button" class="btn border-0 rounded-0 px-3 small secondary-color" @click="next_week">&rarr;</button>
                  <button type="button" class="btn border-0 border-start rounded-0 px-4 small secondary-color" @click="go_to_current_week">This week</button>
                </div>
                <label for="time-entry-month-filter" class="small fw-semibold secondary-color mb-0">Month</label>
                <select
                  id="time-entry-month-filter"
                  v-model="selected_month"
                  class="form-select form-select-sm entity-binding-control rounded-pill px-4 w-auto"
                >
                  <option v-for="month in months" :key="month.value" :value="month.value">{{ month.label }}</option>
                </select>
              </div>

              <div class="d-flex align-items-center gap-2 flex-wrap justify-content-xl-end">
                <button type="button" class="btn btn-primary-dark btn-sm rounded-small px-3" @click="add_case_row">Add a case row</button>
                <button type="button" class="btn btn-primary-dark btn-sm rounded-small px-3">Export</button>
                <button type="button" class="btn btn-primary-dark btn-sm rounded-small px-3" @click="open_submit_week_modal">Submit week</button>
              </div>
            </div>

            <div v-if="selected_week_submitted_sheet" class="alert border rounded-4 py-3 px-3 mb-3" :class="selected_week_submitted_sheet.status_key === 'disputed' ? 'alert-warning' : selected_week_submitted_sheet.status_key === 'approved' ? 'alert-success' : 'alert-light'">
              <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                <div>
                  <div class="small fw-semibold text-uppercase mb-1">Submitted week</div>
                  <div class="fw-semibold mb-1">{{ selected_week_submitted_sheet.week_label }} - {{ selected_week_submitted_sheet.status }}</div>
                  <div class="small mb-0">{{ selected_week_submitted_sheet.comment || selected_week_submitted_sheet.change }}</div>
                </div>
                <span class="badge rounded-pill fw-normal align-self-start" :class="selected_week_submitted_sheet.status_badge_class">
                  {{ selected_week_submitted_sheet.status }}
                </span>
              </div>
            </div>

            <div class="entity-vibrant-binding-card case-owner-timesheet-summary-card rounded-4 bg-white border shadow-sm p-3 mb-3">
              <div class="row g-3 align-items-center">
                <div class="col-12 col-md-6 col-xl-3">
                  <div class="text-uppercase text-xxs secondary-color mb-1">Billable hours</div>
                  <div class="case-owner-timesheet-summary-value">{{ detail_summary.billable_hours }}</div>
                  <div class="small secondary-color">{{ detail_summary.billable_meta }}</div>
                </div>
                <div class="col-12 col-md-6 col-xl-4">
                  <div class="text-uppercase text-xxs secondary-color mb-1">Non-billable</div>
                  <div class="case-owner-timesheet-summary-value">{{ detail_summary.non_billable_hours }}</div>
                  <div class="small secondary-color">{{ detail_summary.non_billable_meta }}</div>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <div class="text-uppercase text-xxs secondary-color mb-1">Total this week</div>
                  <div class="case-owner-timesheet-summary-value">{{ detail_summary.total_hours }}</div>
                  <div class="small secondary-color">{{ detail_summary.total_meta }}</div>
                </div>
                <div class="col-12 col-md-6 col-xl-2">
                  <div class="case-owner-timesheet-rate-box">
                    <div class="small secondary-color">{{ detail_summary.rate_label }}</div>
                    <div class="case-owner-timesheet-rate-value">{{ detail_summary.rate_value }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="company-cases-table-wrap shadow">
              <div class="table-responsive case-owner-timesheet-table-wrap">
                <table class="table company-cases-table align-middle mb-0 case-owner-timesheet-table w-100 case-owner-timesheet-grid-table">
                  <thead>
                    <tr class="case-owner-timesheet-grid-head-row">
                      <th class="case-owner-timesheet-case-col case-owner-timesheet-grid-th case-owner-timesheet-grid-th-case">Case - Billable?</th>
                      <th v-for="column in columns" :key="column" class="text-center case-owner-timesheet-grid-th case-owner-timesheet-grid-th-day">
                        {{ column }}
                      </th>
                      <th class="text-center case-owner-timesheet-grid-th case-owner-timesheet-grid-th-total">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in rows" :key="`${row.code}-${row.title}`">
                      <td class="px-3 py-3 align-top case-owner-timesheet-grid-td case-owner-timesheet-grid-td-case">
                        <button
                          v-if="is_case_row(row.code)"
                          type="button"
                          class="btn case-link-button p-0 border-0 text-start w-100"
                          @click="go_to_case_detail(row.code)"
                        >
                          <div class="text-uppercase text-xxs secondary-color mb-1">{{ row.code }}</div>
                          <div class="company-case-title case-owner-timesheet-grid-title">{{ row.title }}</div>
                        </button>
                        <div v-else>
                          <div class="text-uppercase text-xxs secondary-color mb-1">{{ row.code }}</div>
                          <div class="company-case-title case-owner-timesheet-grid-title">{{ row.title }}</div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                          <div v-if="row.activity_label && !is_case_row(row.code)" class="company-case-subtitle mb-0">{{ row.activity_label }}</div>
                          <span class="badge rounded-pill fw-normal case-owner-timesheet-tag px-3 py-2" :class="row.tag_class">{{ row.tag }}</span>
                        </div>
                      </td>
                      <td v-for="(value, index) in row.values" :key="`${row.title}-${index}`" class="px-0 py-0 text-center case-owner-timesheet-grid-td case-owner-timesheet-grid-td-day">
                        <button
                          type="button"
                          class="case-owner-timesheet-cell case-owner-timesheet-cell-button case-owner-timesheet-grid-cell"
                          @click="edit_cell(row, index)"
                        >
                          <span>{{ value }}</span>
                          <span v-if="pending_evidence_count(row, index)" class="d-block small secondary-color">
                            {{ pending_evidence_count(row, index) }} evidence
                          </span>
                        </button>
                      </td>
                      <td class="px-3 py-3 text-center fw-bold secondary-color case-owner-timesheet-grid-td case-owner-timesheet-grid-td-total">{{ row.total }}</td>
                    </tr>

                    <tr class="case-owner-timesheet-day-total-row">
                      <td class="px-3 py-3 fw-bold text-uppercase secondary-color case-owner-timesheet-total-cell case-owner-timesheet-total-label">Day totals</td>
                      <td v-for="(total, index) in day_totals" :key="`total-${index}`" class="px-3 py-3 text-center fw-bold secondary-color case-owner-timesheet-total-cell case-owner-timesheet-total-value">
                        {{ total }}
                      </td>
                      <td class="px-3 py-3 text-center case-owner-timesheet-total-cell"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="d-flex flex-column flex-xl-row align-items-xl-end justify-content-between gap-3 mt-3">
              <div class="small secondary-color d-flex align-items-center gap-2 flex-wrap">
                <span class="badge bg-white text-secondary border fw-normal px-2 py-1">Tab</span>
                <span>next cell</span>
                <span>-</span>
                <span class="badge bg-white text-secondary border fw-normal px-2 py-1">Shift+Tab</span>
                <span>previous</span>
                <span>- totals update live -</span>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3 mb-3">
              <div>
                <h2 class="fs-6 fw-bold mb-1">Submitted timesheets</h2>
                <div class="entity-panel-caption small text-dark">{{ selected_month_label || '-' }} &middot; {{ month_scoped_submitted_timesheets.length }} weeks in scope</div>
              </div>
            </div>

            <div class="company-cases-table-wrap shadow">
              <div class="table-responsive">
                <table class="table company-cases-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Week</th>
                      <th>Cases</th>
                      <th>Billable</th>
                      <th>Non-Bill</th>
                      <th>Total</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Comment</th>
                      <th class="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sheet in month_scoped_submitted_timesheets" :key="sheet.id">
                      <td class="px-3 py-3">
                        <div class="company-case-title">{{ sheet.week_label }}</div>
                        <div class="company-case-subtitle">{{ sheet.change }}</div>
                      </td>
                      <td class="px-3 py-3">
                        <div class="company-case-owner">{{ sheet.cases }}</div>
                      </td>
                      <td class="px-3 py-3">
                        <div class="company-case-owner secondary-color">{{ sheet.billable_hours }}</div>
                      </td>
                      <td class="px-3 py-3">
                        <div class="company-case-owner text-secondary">{{ sheet.non_billable_hours }}</div>
                      </td>
                      <td class="px-3 py-3">
                        <div class="company-case-owner">{{ sheet.total_hours }}</div>
                      </td>
                      <td class="px-3 py-3">
                        <div class="company-case-title">{{ sheet.amount }}</div>
                      </td>
                      <td class="px-3 py-3">
                        <span class="company-case-domain" :class="sheet.status_badge_class">
                          {{ sheet.status }}
                        </span>
                      </td>
                      <td class="px-3 py-3">
                        <div class="company-case-subtitle">{{ sheet.comment || 'No reviewer comment left.' }}</div>
                      </td>
                      <td class="px-3 py-3 text-end">
                        <div class="company-case-actions justify-content-end">
                          <button
                            type="button"
                            class="company-case-view-btn"
                            @click="edit_submitted_timesheet(sheet)"
                          >
                            Edit week
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="!loading_entries && !month_scoped_submitted_timesheets.length">
                      <td colspan="9" class="px-4 py-4 text-center text-secondary small">No submitted timesheets yet.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div
    v-if="should_render_active_modal"
    class="case-owner-timesheet-modal-backdrop d-flex align-items-center justify-content-center"
    @click.self="close_modal"
  >
    <div
      class="case-owner-timesheet-modal bg-white border shadow-lg"
      :class="{
        'case-owner-timesheet-modal-compact': active_modal === 'feedback',
        'case-owner-timesheet-modal-wide': active_modal === 'submit-week'
      }"
      role="dialog"
      aria-modal="true"
    >
      <div v-if="active_modal === 'edit-cell'">
        <div class="case-owner-timesheet-modal-header d-flex align-items-start justify-content-between gap-3">
          <div>
            <div class="text-uppercase text-xxs secondary-color mb-2">Edit hours</div>
            <h2 class="case-owner-timesheet-modal-title mb-1">{{ editing_cell.row && editing_cell.row.title }}</h2>
            <p class="case-owner-timesheet-modal-copy mb-0">{{ format_column_day(editing_cell.date) }}</p>
          </div>
          <button type="button" class="case-owner-timesheet-modal-close" aria-label="Close" @click="close_modal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="case-owner-timesheet-modal-body">
          <div class="case-owner-timesheet-modal-summary-grid">
            <div class="case-owner-timesheet-modal-summary-card">
              <span class="text-uppercase text-xxs secondary-color">Already logged</span>
              <strong>{{ format_hours(editing_cell.existing_hours) }}</strong>
            </div>
            <div class="case-owner-timesheet-modal-summary-card">
              <span class="text-uppercase text-xxs secondary-color">Pending draft</span>
              <strong>{{ format_hours(editing_cell.pending_hours) }}</strong>
            </div>
          </div>

          <label class="case-owner-timesheet-modal-label" for="timesheet-hours-input">Additional hours</label>
          <input
            id="timesheet-hours-input"
            v-model="editing_cell.input"
            type="text"
            class="form-control case-owner-timesheet-modal-input"
            placeholder="0,5"
          />
          <p class="case-owner-timesheet-modal-copy mb-0">Enter `0` to clear the pending draft for this day.</p>
        </div>

        <div class="case-owner-timesheet-modal-footer d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light border rounded-small px-3" @click="close_modal">Cancel</button>
          <button type="button" class="btn btn-primary-dark rounded-small px-3" @click="save_cell_edit">Save hours</button>
        </div>
      </div>

      <div v-else-if="active_modal === 'add-case-row'">
        <div class="case-owner-timesheet-modal-header d-flex align-items-start justify-content-between gap-3">
          <div>
            <div class="text-uppercase text-xxs secondary-color mb-2">Add time row</div>
            <h2 class="case-owner-timesheet-modal-title mb-1">Select a case and activity</h2>
            <p class="case-owner-timesheet-modal-copy mb-0">Use the same details you would log under the case `Time` tab, then add the hours in the weekly grid.</p>
          </div>
          <button type="button" class="case-owner-timesheet-modal-close" aria-label="Close" @click="close_modal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="case-owner-timesheet-modal-body">
          <label class="case-owner-timesheet-modal-label" for="timesheet-case-select">Case</label>
          <select
            id="timesheet-case-select"
            v-model="add_case_form.application_id"
            class="form-select case-owner-timesheet-modal-input"
          >
            <option disabled value="">Select a case</option>
            <option
              v-for="case_item in selectable_cases"
              :key="case_item.application_id"
              :value="String(case_item.application_id)"
            >
              {{ case_item.case_code }} - {{ case_item.title }}
            </option>
          </select>

          <label class="case-owner-timesheet-modal-label" for="timesheet-activity-input">Activity</label>
          <input
            id="timesheet-activity-input"
            v-model="add_case_form.activity"
            type="text"
            class="form-control case-owner-timesheet-modal-input"
            placeholder="e.g. Inspection brief"
          />

          <div class="case-owner-timesheet-modal-label">Billable?</div>
          <div class="d-flex align-items-center gap-2">
            <button
              type="button"
              class="btn btn-light border rounded-small flex-fill"
              :class="{ active: add_case_form.billable }"
              @click="add_case_form.billable = true"
            >
              Yes
            </button>
            <button
              type="button"
              class="btn btn-light border rounded-small flex-fill"
              :class="{ active: !add_case_form.billable }"
              @click="add_case_form.billable = false"
            >
              No
            </button>
          </div>

          <div class="row g-3 mt-1">
            <div class="col-12 col-md-7">
              <label class="case-owner-timesheet-modal-label" for="timesheet-day-select">Day</label>
              <select
                id="timesheet-day-select"
                v-model="add_case_form.day_key"
                class="form-select case-owner-timesheet-modal-input"
              >
                <option disabled value="">Select a day</option>
                <option
                  v-for="day in selectable_week_days"
                  :key="day.key"
                  :value="day.key"
                >
                  {{ day.label }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-5">
              <label class="case-owner-timesheet-modal-label" for="timesheet-row-hours-input">Hours</label>
              <input
                id="timesheet-row-hours-input"
                v-model="add_case_form.hours"
                type="text"
                class="form-control case-owner-timesheet-modal-input"
                placeholder="0,5"
              />
            </div>
          </div>

          <label class="case-owner-timesheet-modal-label" for="timesheet-evidence-input">Evidence</label>
          <input
            id="timesheet-evidence-input"
            ref="add_case_evidence_input"
            type="file"
            multiple
            accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv"
            class="form-control case-owner-timesheet-modal-input"
            @change="handle_add_case_evidence_change"
          />

          <div v-if="add_case_form.evidence_files.length" class="d-flex flex-wrap gap-2 mt-3">
            <span
              v-for="(file, index) in add_case_form.evidence_files"
              :key="`${file.name}-${index}`"
              class="badge rounded-pill bg-light text-dark border d-inline-flex align-items-center gap-2 px-3 py-2"
            >
              <span class="text-truncate" style="max-width: 220px;">{{ file.name }}</span>
              <button type="button" class="btn border-0 p-0 lh-1" @click="remove_add_case_evidence(index)">&times;</button>
            </span>
          </div>

          <p class="case-owner-timesheet-modal-copy mb-0">This will create the row, store the entered hours, and attach the evidence when you submit the week.</p>
        </div>

        <div class="case-owner-timesheet-modal-footer d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light border rounded-small px-3" @click="close_modal">Cancel</button>
          <button type="button" class="btn btn-primary-dark rounded-small px-3" @click="save_case_row">Add time</button>
        </div>
      </div>

      <div v-else-if="active_modal === 'submit-week'">
        <div class="case-owner-timesheet-modal-header d-flex align-items-start justify-content-between gap-3">
          <div>
            <div class="text-uppercase text-xxs secondary-color mb-2">Submit week</div>
            <h2 class="case-owner-timesheet-modal-title mb-1">Choose the review destination</h2>
            <p class="case-owner-timesheet-modal-copy mb-0">Select who this week's timesheet should be submitted to for review.</p>
          </div>
          <button type="button" class="case-owner-timesheet-modal-close" aria-label="Close" @click="close_modal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="case-owner-timesheet-modal-body">
          <div class="case-owner-timesheet-modal-summary-grid">
            <div class="case-owner-timesheet-modal-summary-card">
              <span class="text-uppercase text-xxs secondary-color">Week total</span>
              <strong>{{ detail_summary.total_hours }}</strong>
            </div>
            <div class="case-owner-timesheet-modal-summary-card">
              <span class="text-uppercase text-xxs secondary-color">Billable split</span>
              <strong>{{ detail_summary.total_meta }}</strong>
            </div>
          </div>

          <div class="case-owner-timesheet-review-grid">
            <button
              type="button"
              class="case-owner-timesheet-review-option text-start"
              :class="{ 'is-selected': submit_review_target === 'coordinator' }"
              @click="submit_review_target = 'coordinator'"
            >
              <span class="case-owner-timesheet-review-radio" :class="{ 'is-selected': submit_review_target === 'coordinator' }"></span>
              <span class="d-block fw-bold mb-1">Coordinator</span>
              <span class="case-owner-timesheet-modal-copy d-block mb-0">Route this timesheet to the coordinator for first review.</span>
            </button>

            <button
              type="button"
              class="case-owner-timesheet-review-option text-start"
              :class="{ 'is-selected': submit_review_target === 'system-admin' }"
              @click="submit_review_target = 'system-admin'"
            >
              <span class="case-owner-timesheet-review-radio" :class="{ 'is-selected': submit_review_target === 'system-admin' }"></span>
              <span class="d-block fw-bold mb-1">System Admin</span>
              <span class="case-owner-timesheet-modal-copy d-block mb-0">Send this timesheet directly to the system admin for review.</span>
            </button>
          </div>
        </div>

        <div class="case-owner-timesheet-modal-footer d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light border rounded-small px-3" @click="close_modal" :disabled="submitting_week">Cancel</button>
          <button type="button" class="btn btn-primary-dark rounded-small px-3" @click="submit_week" :disabled="submitting_week">
            {{ submitting_week ? 'Submitting...' : `Submit to ${submit_review_target_label}` }}
          </button>
        </div>
      </div>

      <div v-else-if="active_modal === 'feedback'">
        <div class="case-owner-timesheet-modal-header d-flex align-items-start justify-content-between gap-3">
          <div>
            <div class="text-uppercase text-xxs secondary-color mb-2">Timesheet message</div>
            <h2 class="case-owner-timesheet-modal-title mb-0">{{ feedback_modal.title }}</h2>
          </div>
          <button type="button" class="case-owner-timesheet-modal-close" aria-label="Close" @click="close_modal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="case-owner-timesheet-modal-body">
          <div class="case-owner-timesheet-feedback" :class="`is-${feedback_modal.tone}`">
            {{ feedback_modal.message }}
          </div>
        </div>

        <div class="case-owner-timesheet-modal-footer d-flex justify-content-end">
          <button type="button" class="btn btn-primary-dark rounded-small px-3" @click="close_modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
